module.exports = require("del");